/**
 * Stable error codes returned by whatsapp-business-service's
 * POST /whatsapp-api/account (embedded-signup connect endpoint).
 *
 * Source of truth: whatsapp-business-service
 * internal/messaging/infrastructure/adapters/InternalErrorMapper.go
 * (internal code 4009) — documented in that repo's
 * docs/architecture/SERVICE_CONTRACT.md. Keep both sides in sync
 * (RET-1016 cross-reference convention).
 *
 * INT-914: Meta's debug_token reported no WhatsApp Business Account access
 * for the exchanged token — the user finished the Meta popup without
 * selecting/granting a WABA. Rendered as HTTP 422 with this code; the
 * connect failure screen maps it to actionable copy instead of the false
 * "Meta no permitió la conexión".
 */
export const WHATSAPP_BUSINESS_NO_WABA_IN_TOKEN = 'wba-10073';

/**
 * Stable error code returned by whatsapp-business-service's
 * POST /whatsapp-api/account (embedded-signup connect endpoint).
 *
 * Source of truth: whatsapp-business-service
 * internal/messaging/infrastructure/adapters/InternalErrorMapper.go
 * (internal code 4042) — documented in that repo's
 * docs/architecture/SERVICE_CONTRACT.md. Keep both sides in sync.
 *
 * The WhatsApp Business Account or phone number selected in the Meta popup is
 * already connected to another Leadsales workspace. Rendered as HTTP 422 with
 * this code; the connect failure screen maps it to copy that asks for a
 * different number, because a plain retry cannot succeed until the number is
 * released on the other side.
 */
export const WHATSAPP_BUSINESS_WABA_IN_USE_BY_ANOTHER_WORKSPACE = 'wba-10109';

/**
 * Error code the connection state machine sets itself, not one the backend
 * returns: the Facebook SDK did not load within the wait limit, so Meta's
 * window could never open (a slow connection or a content blocker). The
 * connect failure screen maps it to copy that names that cause and invites a
 * retry, instead of blaming Meta.
 */
export const WHATSAPP_SDK_TIMEOUT_ERROR_CODE = 'wapi-sdk-timeout';
